"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDate = exports.parseDate = exports.getDatePstFormat = exports.setTimeZoneByName = exports.getFormattedTimeWithZeroPrefix = exports.getTimeZoneNameFromAdddress = exports.getTimeZoneName = exports.normalizeDate = exports.endOfDayFromISODateCountryState = exports.addUTCOffsetForCountryState = exports.getUTCOffset = exports.yyyyMmInt = exports.yyyyMm = exports.ISODatePeriod = exports.dateToString = exports.ISODate = exports.DATE_FORMAT = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
exports.DATE_FORMAT = "yyyy-MM-dd";
var ISODate;
(function (ISODate) {
    function fromDate(date) {
        return date ? date_fns_1.formatISO(date).substring(0, 10) : "";
    }
    ISODate.fromDate = fromDate;
})(ISODate = exports.ISODate || (exports.ISODate = {}));
function dateToString(date) {
    if (date) {
        return date_fns_1.format(date, exports.DATE_FORMAT);
    }
    return "";
}
exports.dateToString = dateToString;
class ISODatePeriod {
    constructor(startDate, endDate) {
        this.startDate = startDate;
        this.endDate = endDate;
    }
    static fromObj(data) {
        return new ISODatePeriod(data.startDate, data.endDate);
    }
    static fromDates(startDate, endDate) {
        return new ISODatePeriod(ISODate.fromDate(startDate), ISODate.fromDate(endDate));
    }
    in(date) {
        const isoDate = typeof date !== "string" ? ISODate.fromDate(date) : date;
        return isoDate >= this.startDate && isoDate <= this.endDate;
    }
}
exports.ISODatePeriod = ISODatePeriod;
const yyyyMm = (aDate) => {
    let date;
    if (typeof aDate === "string") {
        date = date_fns_1.parseISO(aDate);
    }
    else {
        date = new Date();
    }
    return date_fns_1.format(date, "yyyyMM");
};
exports.yyyyMm = yyyyMm;
const yyyyMmInt = (date) => parseInt(exports.yyyyMm(date), 10);
exports.yyyyMmInt = yyyyMmInt;
function getUTCOffset(country = "USA", state = "") {
    if (country === "USA") {
        if (state && state !== "HI") {
            return "-08:00";
        }
        return "-10:00";
    }
    if (["CAN"].includes(country)) {
        return "-08:00";
    }
    return "";
}
exports.getUTCOffset = getUTCOffset;
function addUTCOffsetForCountryState(isoDateStr, country, state) {
    const offset = getUTCOffset(country, state);
    const date = date_fns_1.parseISO(isoDateStr);
    const dateTimeStr = `${date.toISOString().substring(0, 23)}${offset}`;
    return date_fns_1.parseJSON(dateTimeStr);
}
exports.addUTCOffsetForCountryState = addUTCOffsetForCountryState;
function endOfDayFromISODateCountryState(isoDateStr, country, state) {
    return addUTCOffsetForCountryState(`${isoDateStr.substring(0, 10)}T23:59:59.999Z`, country, state);
}
exports.endOfDayFromISODateCountryState = endOfDayFromISODateCountryState;
const normalizeDate = (date, dateDisplayFormat = false) => {
    const offset = new Date().getTimezoneOffset();
    if (dateDisplayFormat)
        return offset > 0 ? date_fns_1.addMinutes(date, offset) : date_fns_1.subMinutes(date, offset);
    return offset < 0 ? date_fns_1.addMinutes(date, offset) : date_fns_1.subMinutes(date, offset);
};
exports.normalizeDate = normalizeDate;
const getTimeZoneName = (country = "USA", state = "") => {
    let IANATimeZoneName;
    if (country === "USA") {
        if (state === "HI")
            IANATimeZoneName = "Pacific/Tahiti";
        else
            IANATimeZoneName = "America/Los_Angeles";
    }
    else if (["CAN"].includes(country)) {
        IANATimeZoneName = "America/Los_Angeles";
    }
    return IANATimeZoneName;
};
exports.getTimeZoneName = getTimeZoneName;
const getTimeZoneNameFromAdddress = (address) => {
    const { country, state } = address;
    return exports.getTimeZoneName(country, state);
};
exports.getTimeZoneNameFromAdddress = getTimeZoneNameFromAdddress;
const getFormattedTimeWithZeroPrefix = (hour, minutes, seconds) => {
    const formattedHour = `0${hour}`.slice(-2);
    const formattedMinutes = `0${minutes}`.slice(-2);
    const formattedSeconds = `0${seconds}`.slice(-2);
    return `${formattedHour}:${formattedMinutes}:${formattedSeconds}`;
};
exports.getFormattedTimeWithZeroPrefix = getFormattedTimeWithZeroPrefix;
const setTimeZoneByName = (date, partnerTimeZoneName = "America/Los_Angeles", dateFormatFound) => date_fns_tz_1.format(date, dateFormatFound || "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", {
    timeZone: partnerTimeZoneName
});
exports.setTimeZoneByName = setTimeZoneByName;
const getDatePstFormat = (date, timeZoneName) => {
    if (date) {
        const dateToDisplay = date_fns_tz_1.utcToZonedTime(new Date(date).toISOString(), timeZoneName);
        const dateFormated = exports.setTimeZoneByName(dateToDisplay, timeZoneName);
        return dateFormated.split("T")[0];
    }
    return date;
};
exports.getDatePstFormat = getDatePstFormat;
const parseDate = (date, partnerTimeZoneName, datePresentationFormat) => {
    let i = 0;
    let tempDate;
    let dateFormated;
    const dateFormats = [
        "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
        "yyyy-MM-dd'T'HH:mm:ssXXX",
        "yyyy/MM/dd",
        "yyyy-MM-dd",
        "MM/dd/yyyy",
        "MM/dd/yyyy HHmm"
    ];
    if (!date)
        return date;
    if (datePresentationFormat && partnerTimeZoneName) {
        const dateObject = new Date(typeof date === "string" && date.length === 10
            ? date.replace(/-/g, "/")
            : date);
        dateObject.setHours(12, 0, 0, 0);
        const dateToDisplay = date_fns_tz_1.utcToZonedTime(dateObject.toISOString(), partnerTimeZoneName);
        const dateToDisplayTz = exports.setTimeZoneByName(dateToDisplay, partnerTimeZoneName);
        return dateToDisplayTz.split("T")[0];
    }
    if (date instanceof Date) {
        dateFormated = exports.setTimeZoneByName(date, partnerTimeZoneName);
    }
    else
        dateFormated = date;
    while (i < dateFormats.length) {
        tempDate = date_fns_1.parse(dateFormated, dateFormats[i], new Date());
        if (String(tempDate) !== "Invalid Date") {
            const dateFormatFound = dateFormats[i];
            if (!dateFormatFound.includes("HH"))
                tempDate = date_fns_1.setHours(tempDate, 12);
            if (!dateFormatFound.includes("XXX"))
                return exports.setTimeZoneByName(tempDate, partnerTimeZoneName);
            if (dateFormatFound.includes("XXX"))
                return dateFormated;
            break;
        }
        i += 1;
    }
    if (String(tempDate) === "Invalid Date")
        throw Error(`Invalid format date '${dateFormated}'. The allowed date format are: ${dateFormats.join(", ")} `);
    return new Date(tempDate).toISOString();
};
exports.parseDate = parseDate;
const getDate = (date) => {
    if (date instanceof Date)
        return date;
    return new Date(date.length === 10 ? date.replace(/-/g, "/") : date);
};
exports.getDate = getDate;
//# sourceMappingURL=index.js.map